import { css } from '@emotion/core';

const styles = theme => {
  const strokeColors = `
    & circle.vds-progress--spinner-bar {
      stroke: ${theme?.cybs?.core?.primary ?? '#1434CB'};
    }
    & circle.vds-progress--spinner-background {
      stroke: #FCC015;
    }
  `;

  return {
    dialog: css`
      & .vds-dialog-card {
        width: auto !important;
        max-width: max-content !important;
        border: 1px solid ${theme?.cybs?.base?.wcag21?.stoneGrey?? '#62798D'};
      }

      & .vds-dialog-card--head {
        display: none;
      }

      & .vds-dialog-card--body {
        padding: 0;
      }

      & .vds-dialog-card--footer {
        ${theme && theme.classes
          ? theme.classes.structure.padding.space.all[2]
          : 'padding:1rem;'};
        padding-top: 0;

        & button {
          margin: 0;
        }
      }

      @media (max-height: 350px) {
        & .vds-dialog-card {
          margin-top: 0px;
        }
        & .vds-dialog-card--body {
          padding-bottom: 1rem !important;
        }

        & .vds-progress--spinner {
          margin-top: 1rem !important;
          margin-bottom: 1rem !important;
      
        }
      }

      & div.vds-progress--spinner {
        height: auto;
        width: auto;
        margin: auto;
        text-align: center;
        ${theme && theme.classes
          ? theme.classes.structure.margin.space.top[4]
          : 'padding-right:2rem;'};
        ${theme && theme.classes
          ? theme.classes.structure.margin.space.bottom[3]
          : 'padding-right:1.5rem;'};
      }

      & svg.vds-progress--spinner-track {
        width: 4rem !important;
        height: 4rem !important;
      }

      & .vds-progress--spinner:not(.vds-state--determinate) {
        ${strokeColors}
      }
    `,
    progress: css`
      & svg {
        width: 4rem !important;
        height: 4rem !important;
      }

      &.vds-progress--spinner:not(.vds-state--determinate) {
        ${strokeColors}
      }

      &.vds-progress--spinner.vds-state--determinate {
        & circle.vds-progress--spinner-bar {
          stroke: ${theme?.cybs?.core?.primary ?? '#1434CB'};
        }
        & circle.vds-progress--spinner-background {
          stroke: ${theme?.vds?.tableHighlight ?? '#C7EDFF'};
        }
    
        .vds-progress-label {
          font-weight: 600;
          top: -2px;
          text-indent: -5px;
          color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
        }
      }
    `,
    default: css`
      display: flex !important;
      align-items: center;
      justify-content: center;
      width: 100vw;
      height: 100vh;

      & .vds-progress--spinner {
        width: 5.5rem !important;
        height: 5.5rem !important;
        background: white;
        padding: 0.75rem;
        border-radius: 100%;
        border: 1px solid ${theme?.cybs?.base?.wcag21?.stoneGrey?? '#62798D'};

        & svg {
          height: 4rem;
          width: 4rem;
        }
      }

      & .vds-progress--spinner:not(.vds-state--determinate) {
        ${strokeColors}
      }
    `
  };
};

export default styles;
